// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_1EHDA grid grid--col-12","ColLeft":"Content__ColLeft_1ZEDB","ColRight":"Content__ColRight_1PBOu d-none d-sm-block"};